/* eslint-disable react/jsx-no-target-blank */
import CourseRankingCardSimple from "@modules/study/common/course_ranking_card_simple";
import { Grid } from "@mui/material";
import {
  calcDuration,
  htmlParse,
  isCourseCompare,
  isCourseFavorite,
} from "@unisearch/helpers";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { AiOutlineDollar } from "react-icons/ai";
import { BiCalendar } from "react-icons/bi";
import { FiClock } from "react-icons/fi";
import { saveAs } from "file-saver";
import { MdPictureAsPdf, MdSchool } from "react-icons/md";
import { useRecoilValue } from "recoil";
import styles from "./uni_course_details.module.scss";
import { DownloadGuide } from "@unisearch/common";

const FavoriteAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/favorite"),
  { ssr: false }
);

const CompareAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/compare"),
  { ssr: false }
);

export const UniCourseDetails = ({
  courseDetailsData,
  universityProfileData,
}) => {
  const totalCost = courseDetailsData?.livingCost?.reduce(
    (acc, curr) => acc + parseInt(curr?.livingValueFrom),
    0
  );

  const profileInfo = useRecoilValue(authAtom);
  const router = useRouter();
  const systemActions = useSystemActions();

  const getSign = async () => {
    systemActions.setReturnUrl(router.asPath);
    await router.push({ pathname: "/signin" });
  };

  const firstYearTutionFee =
    courseDetailsData?.tuition?.length > 0 &&
    courseDetailsData?.tuition?.find(
      (item) => item.tuitionFor === "first_year"
    );

  const intakeArray =
    courseDetailsData?.intake?.length > 0
      ? courseDetailsData.intake.sort((a, b) => a.intakeYear - b.intakeYear)
      : [];

  return (
    <section>
      <div className="container">
        <div
          className={`${styles.course_name_wrapper} ${styles.course_desc_wrapper}`}
        >
          <h2>{courseDetailsData?.course?.courseName}</h2>
          <ul className={styles.scp_card_info_lists}>
            <li>
              <MdSchool className={styles.scp_card_icon} />
              <div className={styles.scp_card_text}>
                <span>Course Level</span>
                <span>{courseDetailsData?.course?.levelName}</span>
              </div>
            </li>
            <li>
              <FiClock className={styles.scp_card_icon} />
              <div className={styles.scp_card_text}>
                <span>Course Duration</span>
                <span>
                  {calcDuration(courseDetailsData?.course?.courseDuration)}
                </span>
              </div>
            </li>

            {intakeArray.length > 0 && (
              <li>
                <BiCalendar className={styles.scp_card_icon} />
                <div className={styles.scp_card_text}>
                  <span>Intake</span>
                  <span>
                    {intakeArray[0]?.admissionSessionName}:{" "}
                    {intakeArray[0]?.intakeMonth} {intakeArray[0]?.intakeYear}{" "}
                  </span>
                </div>
              </li>
            )}
          </ul>
        </div>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={8}>
            <div className={styles.course_desc_wrapper}>
              {courseDetailsData?.course?.courseDescription && (
                <div
                  className={`${styles.course_desc} from_texteditor_wrapper`}
                >
                  <h4>Course Description</h4>

                  {courseDetailsData?.course?.courseDescription
                    ? htmlParse(courseDetailsData?.course?.courseDescription)
                    : ""}

                  {/* <li>
                      <MdCheckCircle />
                      <span>
                        Criminology involves the study of crime, including
                        victimization, criminality, and criminal justice agents
                        and institutions among other areas
                      </span>
                    </li> */}
                </div>
              )}
              <div className={styles.dates_and_fees_wrapper}>
                <div className={styles.course_details_fees_and_dates}>
                  <h3>Start Dates and Fees</h3>
                  <p>
                    Course fees are indicative and should be viewed as an
                    estimate. Connect with{" "}
                    <Link legacyBehavior href="/counsellors">
                      <a>a counsellor</a>
                    </Link>{" "}
                    to get an accurate figure for your course fees!
                  </p>
                  {/* <p>
                    Course fees are indicative and should be used as a guide.
                    <br />
                    <Link  legacyBehavior href="/counsellors">
                      <a>meet to a counsellor</a>
                    </Link>{" "}
                    to get an accurate price.
                  </p> */}

                  <div className={styles.duration_and_fees_box_wrapper}>
                    <div className={styles.duration_and_fees}>
                      {courseDetailsData?.course?.courseDuration && (
                        <div className={styles.duration_fee}>
                          <FiClock />
                          <span>Duration</span>
                          <span className={styles.dufee}>
                            {calcDuration(
                              courseDetailsData?.course?.courseDuration
                            )}
                          </span>
                        </div>
                      )}

                      {courseDetailsData?.tuition?.length > 0 && (
                        <div className={styles.duration_fee}>
                          <AiOutlineDollar />
                          <span>1st Year Tuition Fees</span>
                          <span className={styles.dufee}>
                            {firstYearTutionFee?.amountFrom > 0 &&
                              courseDetailsData?.course?.currencyCode}{" "}
                            {firstYearTutionFee?.amountFrom == 0
                              ? "N/A"
                              : firstYearTutionFee?.amountFrom}
                            {firstYearTutionFee?.amountTo > 0 && (
                              <>
                                {" - "} {firstYearTutionFee?.amountTo}
                              </>
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {intakeArray.length > 0 && (
                  <div className={styles.details_table}>
                    <div className={styles.intake_campus_head}>
                      <h5>Intake</h5>
                      {/* <h5>Intake & Campus</h5> */}
                    </div>
                    <div className={styles.intake_campus_body}>
                      <div className={styles.intake_campus_title}>
                        <span>Intake</span>
                        {/* <span>Campus</span> */}
                      </div>

                      {intakeArray.map((intk, i) => {
                        if (
                          intk?.admissionSessionName &&
                          intk?.admissionSessionName != ""
                        ) {
                          return (
                            <div className={styles.intake_campus_list} key={i}>
                              <span>
                                {intk?.admissionSessionName}:{" "}
                                {intk?.intakeMonth} {intk?.intakeYear}{" "}
                              </span>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                )}

                {courseDetailsData?.livingCost?.length > 0 && (
                  <div className={styles.details_table}>
                    <div className={styles.intake_campus_head}>
                      <h5>Other Costs</h5>
                    </div>
                    <div className={styles.intake_campus_body}>
                      {courseDetailsData?.livingCost?.map((expns, i) => (
                        <div className={styles.cost_list} key={i}>
                          <span>{expns?.livingCostType} :</span>
                          <span style={{ textAlign: "right" }}>
                            {expns?.livingValueFrom}
                          </span>
                        </div>
                      ))}

                      <div className={styles.divider}></div>
                      <div className={styles.cost_total}>
                        <span>Total :</span>
                        <span style={{ textAlign: "right" }}>
                          {courseDetailsData?.course?.currencyCode} {totalCost}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.entry_requirement_wrapper}>
                <h3 className={styles.entry_requirement_heading}>
                  Entry Requirements
                </h3>

                <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
                  {courseDetailsData?.course?.courseRequirement && (
                    <Grid item xs={12}>
                      <div
                        className={`${styles.requirement_card_wrapper} from_texteditor_wrapper`}
                      >
                        <div className={styles.requirement_title}>
                          Academic Requirements
                        </div>

                        {courseDetailsData?.course?.courseRequirement
                          ? htmlParse(
                              courseDetailsData.course.courseRequirement
                            )
                          : ""}
                      </div>
                    </Grid>
                  )}

                  {courseDetailsData?.course?.courseAdditionalInfo && (
                    <Grid item xs={12}>
                      <div
                        className={`${styles.requirement_card_wrapper} from_texteditor_wrapper`}
                      >
                        <div className={styles.requirement_title}>
                          Additional Requirements
                        </div>
                        {courseDetailsData?.course?.courseAdditionalInfo
                          ? htmlParse(
                              courseDetailsData.course.courseAdditionalInfo
                            )
                          : ""}
                      </div>
                    </Grid>
                  )}

                  {courseDetailsData?.examScore?.length > 0 && (
                    <Grid item xs={12}>
                      <div className={styles.requirement_card_wrapper}>
                        <div
                          className={`${styles.requirement_title} ${styles.language_requirement}`}
                        >
                          English Language Requirements
                        </div>
                        <ul className={styles.language_requirement_lists}>
                          {courseDetailsData?.examScore?.map((exam, i) => (
                            <li key={i}>
                              <span
                                className={styles.language_requirement_title}
                              >
                                {exam?.examName} : {exam?.examScore}
                              </span>
                              <div className={`from_texteditor_wrapper`}>
                                {exam?.examSummary
                                  ? htmlParse(exam.examSummary)
                                  : ""}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Grid>
                  )}
                </Grid>
              </div>
              {courseDetailsData?.courseRanking?.length > 0 && (
                <div className={styles.ranking_wrapper}>
                  <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
                    {courseDetailsData?.courseRanking?.map((rank, i) => (
                      <Grid item xs={12} sm={12} md={6} key={i}>
                        <CourseRankingCardSimple
                          rankingYear={rank?.courseRankingYear}
                          rankFrom={rank?.courseRankFrom}
                          rankTo={rank?.courseRankTo}
                          rankingType={rank?.courseRankingType}
                          rankingCompanyName={rank?.rankingCompanyName}
                          rankVarying={rank?.courseRankingVarying}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>
              )}
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            className={styles.course_details_highlight_wrapper}
          >
            <div className={styles.course_hithlights_wrapper}>
              <ul>
                {courseDetailsData?.course?.levelName && (
                  <li>
                    <span className={styles.first_child}>Course Level</span>
                    <span className={styles.last_child}>
                      {courseDetailsData?.course?.levelName}
                    </span>
                  </li>
                )}

                {courseDetailsData?.course?.specializationName && (
                  <li>
                    <span className={styles.first_child}>Specialization</span>
                    <span className={styles.last_child}>
                      {courseDetailsData?.course?.specializationName}
                    </span>
                  </li>
                )}

                {courseDetailsData?.course?.courseDuration && (
                  <li>
                    <span className={styles.first_child}>Course Duration</span>
                    <span className={styles.last_child}>
                      {calcDuration(courseDetailsData?.course?.courseDuration)}
                    </span>
                  </li>
                )}

                {courseDetailsData?.tuition?.length > 0 && (
                  <li>
                    <span className={styles.first_child}>
                      1st Year Tuition Fees
                    </span>

                    <span className={styles.last_child}>
                      {firstYearTutionFee?.amountFrom > 0 &&
                        courseDetailsData?.course?.currencyCode}{" "}
                      {firstYearTutionFee?.amountFrom == 0
                        ? "N/A"
                        : firstYearTutionFee?.amountFrom}
                      {firstYearTutionFee?.amountTo > 0 && (
                        <>
                          {" - "} {firstYearTutionFee?.amountTo}
                        </>
                      )}
                    </span>
                  </li>
                )}

                {intakeArray.length > 0 && (
                  <li>
                    <span className={styles.first_child}>Intake</span>
                    <div style={{ textAlign: "right" }}>
                      {intakeArray.map((intk, i) => {
                        if (
                          intk?.admissionSessionName &&
                          intk?.admissionSessionName != ""
                        ) {
                          return (
                            <div className={styles.last_child} key={i}>
                              <span>
                                {intk?.admissionSessionName}:{" "}
                                {intk?.intakeMonth} {intk?.intakeYear}{" "}
                              </span>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </li>
                )}

                <li>
                  <span className={styles.first_child}>Application Fees</span>
                  <span className={styles.last_child}>
                    {courseDetailsData?.course?.courseApplicationFee &&
                    courseDetailsData?.course?.courseApplicationFee != 0 ? (
                      <>
                        {courseDetailsData?.course?.currencyCode}{" "}
                        {courseDetailsData?.course?.courseApplicationFee}
                      </>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </li>

                {/* <li>
                  <span>campus accommodation</span>
                  <span>Yes</span>
                </li> */}

                {courseDetailsData?.examScore?.length > 0 && (
                  <li>
                    <span className={styles.first_child}>Exam Score</span>
                    <div style={{ textAlign: "right" }}>
                      {courseDetailsData?.examScore?.map((exm, i) => (
                        <span className={styles.last_child} key={i}>
                          {exm?.examName} {exm?.examScore} <br />
                        </span>
                      ))}
                    </div>
                  </li>
                )}
              </ul>
            </div>

            <div className={styles.favorite_and_compare_wrapper}>
              <div className={styles.favorite_wrapper}>
                <FavoriteAction
                  referance="course"
                  referanceId={parseInt(courseDetailsData?.course?.courseId)}
                  is_favorite={isCourseFavorite(
                    profileInfo,
                    courseDetailsData?.course?.courseId
                  )}
                />
                <span>Add to Shortlist</span>
              </div>

              <div className={styles.favorite_wrapper}>
                <CompareAction
                  referance="course"
                  referanceId={parseInt(courseDetailsData?.course?.courseId)}
                  is_compared={isCourseCompare(
                    profileInfo,
                    courseDetailsData?.course?.courseId
                  )}
                />
                <span>Add to Compare</span>
              </div>
            </div>

            {courseDetailsData &&
              courseDetailsData?.course?.prospectusFileSrc && (
                <DownloadGuide
                  customClasses={{ root: "btn-bg btn-full" }}
                  fileSrc={courseDetailsData?.course?.prospectusFileSrc}
                  fileName={"Course Brochure"}
                  documentId={courseDetailsData?.course?.prospectusFileId}
                  documentType="course"
                  universityId={universityProfileData?.universityId}
                />
              )}
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniCourseDetails;
